<div class="text-center col-12">
  <div class="h3">
    <i class="fa fa-exclamation-triangle coution-mark"></i>エラーが発生しました。
  </div>

  <hr />

  <div class="h5">お手数ですが、時間をおいて再度実行してください。</div>
  <div class="h5">同じエラーが出る場合は、管理者までご連絡ください。</div>
</div>

